import { render } from "./OrderProofreading.vue?vue&type=template&id=b804d692&scoped=true"
import script from "./OrderProofreading.vue?vue&type=script&lang=js"
export * from "./OrderProofreading.vue?vue&type=script&lang=js"

import "./OrderProofreading.vue?vue&type=style&index=0&id=b804d692&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b804d692"

export default script